import { render, staticRenderFns } from "./dialogInfo.vue?vue&type=template&id=228e21c6&scoped=true"
import script from "./dialogInfo.vue?vue&type=script&lang=js"
export * from "./dialogInfo.vue?vue&type=script&lang=js"
import style0 from "./dialogInfo.vue?vue&type=style&index=0&id=228e21c6&prod&lang=stylus"
import style1 from "./dialogInfo.vue?vue&type=style&index=1&id=228e21c6&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "228e21c6",
  null
  
)

export default component.exports